store = window.store || {};
store.local = store.local || {};
store.local.onUpdateVariantData = function(variant) {
	var attributes = '';
	$.each(variant.attributes, function(attrIdx, attr) {
		attributes += attr + ' / ';
	});
	attributes = attributes.substr(0, attributes.length - 3);

	$('.product .attributes').html(attributes);
};

store.local.updateMiniCart = function() {
	$.get(store.url(store.action.cartMedium, ''), function (data) {
		$('.cartBoxMedium').replaceWith(data.html);
		$('img.responsive', '.cartBoxMedium').responsiveImg();
	}, 'json');
	$.get(store.url(store.action.cartBox, ''), function (data) {
		$('.miniCart').replaceWith(data.html);
	}, 'json');
};

store.local.onAddToCart = function() {
	store.local.updateMiniCart();
};

store.local.onCartIncrease = function() {
	store.local.updateMiniCart();
};

store.local.onCartDecrease = function() {
	store.local.updateMiniCart();
};

store.local.onInitProduct = function(v) {
	if($('#submitCart').is(':disabled')) {
		$('.addToCart').addClass('disabled');
	}
};

store.local.checkout = function() {
	if ($('body').hasClass('checkout')) {
		$('#billing-billingSameAsShipping').change(function() {
			var $fieldset = $('#fieldset-billing').toggleClass('disabled');
			if ($fieldset.hasClass('disabled')) {
				$fieldset.find('input:not(.checkbox)').attr('disabled', 'disabled');
			}
			else {
				$fieldset.find('input:not(.checkbox)').attr('disabled', null);
			}
		}).change();

		$('ul.paymentTypeSelection li').click(function(){
			$(this).siblings().removeClass('selected');
			$(this).addClass('selected');
		});
	}
};

$(function() {

	$('#storeCartBox').on('click touchstart', function (e) {
		$body = $('body');
		e.preventDefault();
		e.stopPropagation();
		$body.addClass('cart-open');
		site.nav.closeMenu();

		$('body.cart-open').on('click touchstart', function (e) {
			if ($body.hasClass('cart-open')) {
				$('body').removeClass('cart-open');
			}
		});
	});
	store.local.checkout();
});